import { Button,Fab } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';


const Container = styled.div`
  display:flex;
  background: ${props => props.pillStyling ? "#EDEDED" : undefined};
  height: ${props => props.pillStyling ? "44px" : undefined};
  border-radius: ${props => props.pillStyling ? "22px" : undefined};

`;

const ButtonContainer = styled.div`
  padding-left:10px;
  padding-right:10px;
  display:flex;
  align-items:center;
  justify-content:center;

`;



const useStyles = makeStyles(theme => ({
  pillSelected: {
    borderRadius: '12px',
    backgroundColor: 'white',
  },
  pill: {
    borderRadius: '12px',
  }
}));

const SingleSelectButtonGroup = props => {



    const classes = useStyles();


    const { children,value,onValueChanged,pillStyling = false } = props;


        let buttons = children.map(button => {

        return(
          <ButtonContainer
            key={button.props.value}
          >
            {pillStyling ? 
                        <Button 
                        size="small"
                        {...button.props}
                         className={button.props.value === value ? classes.pillSelected : classes.pill}
                         variant={button.props.value === value ? 'contained' : undefined }
                         onClick={event => onValueChanged(button.props.value)}
                         key={button.props.value}
                     />
              :
            <Button 
               {...button.props}
                color="primary"
                variant={button.props.value === value ? 'contained' : 'outlined'}
                onClick={event => onValueChanged(button.props.value)}
                key={button.props.value}
            />
        }
          </ButtonContainer>
        );

      });

    return (
    <Container pillStyling>
        {buttons}
    </Container>

      );


  
}



export default SingleSelectButtonGroup;